import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

import {
  GET_DOWNLOADS_DATA,DOWNLOAD_FILE_BY_ID_API
} from '../endpoints/apiEndpoints'

export const getDowloadsData = async (payload) => {
  const url = urlBuilder(GET_DOWNLOADS_DATA)
  const requestHeader = buildRequestHeader('POST',payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}



export const downloadFileById = async (payload) => {
  const url = urlBuilder(DOWNLOAD_FILE_BY_ID_API)
  const requestHeader = buildRequestHeader('POST',payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}